// extracted by mini-css-extract-plugin
export default {"container":"Legal_container__21Tr5"};